// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b460acb40bfceba2d337","655":"50787d45a29c7b1d92ad"}[chunkId] + ".js";
};